import React, { useContext, useState } from "react";
import { IoClose } from "react-icons/io5";
import BlueLoader from "../loader/BlueLoader";
import axios from "axios";
import { useCookies } from "react-cookie";
import { useNavigate } from "react-router-dom";
import globalContext from "../../Contexts/GlobalContext";
import { SERVERMODE } from "../../constants/serverMode";
import { SERVERMESSAGE } from "../../constants/serverMessage";
import { handleServerMode } from "../../utils/handleServer";
import useRequestHeader from "../../hooks/useRequestHeader";

export default function ServicePlaceDescModal({
  setIsDescModalOpen,
  lat,
  lng,
  referenceTimeId,
  address,
}) {
  /// root api address section start ///
  const BASE_URL = process.env.REACT_APP_ROOT_API_ADDRESS;
  const contextData = useContext(globalContext);
  const requestHeader = useRequestHeader();
  /// root api address section end ///
  const navigate = useNavigate();
  const [cookies, setCookies, removeCookies] = useCookies();
  const [desc, setDesc] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const sendRequest = () => {
    setIsLoading(true);
    const config = {
      headers: requestHeader,
    };
    axios
      .post(
        `${BASE_URL}/service/place/set`,
        {
          plate: cookies?.plate,
          type: cookies?.servicePlaceType,
          mode: "SET",
          address: address,
          latitude: `${lat}`,
          longitude: `${lng}`,
          description: desc,
          referenceDate: referenceTimeId,
        },
        config
      )
      .then((res) => {
        var responseMode = res?.data?.Mode;
        var responseMessage = res?.data?.Message;
        switch (responseMode) {
          case SERVERMODE.REQUEST_OK: {
            setCookies(
              "successMessageOfServicePlace",
              SERVERMESSAGE.SUCCESS_SET_SERVICE_PLACE
            );
            navigate("/servicePlace");
            break;
          }
          default: {
            handleServerMode(
              responseMode,
              responseMessage,
              contextData,
              cookies,
              removeCookies,
              navigate
            );
          }
        }

        setIsLoading(false);
      })
      .catch((err) => {
        setIsDescModalOpen(false);
        contextData.setIsToastOpen(true);
        contextData.setToastMessage("ارتباط با سرور دچار مشکل شده است");
        setIsLoading(false);
      });
  };
  return (
    <div
      className="absolute w-full h-screen top-0 backdrop-blur-sm flex items-center justify-center z-[1000]"
      id="bg"
      onClick={(e) => {
        if (e.target.id === "bg") setIsDescModalOpen(false);
      }}
    >
      <div
        className={`relative w-[80vw] pb-[3vw] bg-[#001D26] border-color-primary-D flex flex-col items-center justify-center border-[1px] z-[800] rounded-[1vw] gap-y-[3.7vw]`}
      >
        <div
          className="w-full flex items-center justify-center bg-color-primary-D font-font_primary_A text-[#153038] "
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          <span className="py-[2vw]">توضیحات</span>
        </div>
        <span
          className={`w-full  text-[3.5vw] text-center z-[800] text-color-primary-C3 font-font_primary_A px-[2vw] `}
        >
          در صورت نیاز می‌توانید برای سرویس کار، توضیحات خود را اضافه نمایید
        </span>

        <div className="relative w-full flex flex-col items-center justify-center mt-[4vw] px-[3vw] gap-y-[1vw]">
          <div className="w-full relative flex items-center justify-between">
            <label
              htmlFor="desc"
              className="font-font_primary_A text-[4vw] text-color-primary-D"
            >
              متن توضیحات:
            </label>
            <span
              className={`absolute left-[1vw] top-[2vw] font-font_primary_A text-[3vw] ${
                desc?.length === 500 ? "text-[#ff0000]" : "text-color-primary-D"
              }  h-full`}
            >
              {desc?.length}/500
            </span>
          </div>
          <textarea
            autoComplete={"off"}
            dir="rtl"
            id="desc"
            value={desc}
            maxLength={500}
            className={`w-full h-[45vw] outline-none bg-transparent border-[1px] border-[#474747] rounded-[1.8vw] text-[3.5vw] focus:text-[3.5vw] py-[1vw] px-[4vw] text-color-primary-A`}
            onChange={(e) => {
              setDesc(e.target.value);
            }}
          ></textarea>
        </div>

        <div className="w-full flex items-center justify-center   ">
          {isLoading ? (
            <div className="relative w-[62.26415094339623vw] h-[11.28301886792453vw]  rounded-[0.78125vw] text-center flex items-center justify-center text-[#474747] font-font_primary_A text-[5vw] bg-color-primary-D z-[1000]">
              <BlueLoader position="" width={7} />
            </div>
          ) : (
            <button
              className={`relative w-[62.26415094339623vw] h-[11.28301886792453vw] rounded-[0.78125vw] text-center flex items-center justify-center text-[#474747] font-font_primary_A text-[5vw] ${
                Number(100) < Number(200)
                  ? "bg-color-primary-D"
                  : "bg-color-primary-C3"
              } z-[1000]`}
              onClick={sendRequest}
            >
              ثبت
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
